import { useContext, useState } from 'react';
import { JSEncrypt } from 'jsencrypt';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import { notifyMeOTPInitiate } from '../../api/api';
import NotifyMeLogin from './NotifyMeLogin/NotifyMeLogin';
import NotifyMeOTP from './NotifyMeOTP/NotifyMeOTP';
import ErrorModal from '../ErrorModal/ErrorModal';
import './NotifyMe.scss'

const win: any = window;

const NotifyMe = () => {
  const { state, dispatch }: any = useContext(GlobalContext);
  const { productData, notifysubPageToDisplay, lang, rtl } = state;
  const { t } = useTranslation()
  const [isGenericError, setIsGenericError] = useState(false);

  const cemPublicKey = win['cem_public_key'];
  const jsencrypt = new JSEncrypt();
  jsencrypt.setPublicKey(cemPublicKey);

  // async function submitForm(formValues: any) {
  //   try {
  //     const mobileNum = formValues["mobileNumber"] as string;
  //     console.log("mobileNum", mobileNum)
  //     const mobileNumber = mobileNum.replace(/^0/, "966");
  //     const productName = lang == "en" ? productData?.name?.valueEn : productData?.name?.valueAr;
  //     const encryptedACNumber = mobileNumber ? jsencrypt.encrypt(mobileNumber) : "";
  //     const encryptedProductName = productName ? jsencrypt.encrypt(productName) : "";
  //     const response = await notifyMeOTPInitiate(lang, encryptedACNumber, encryptedProductName);
  //     if (response.status === 200) {
  //       dispatch({
  //         type: 'NOTIFY_DATA',
  //         payload: { mobile: formValues["mobileNumber"], email: formValues["email"], refId: response?.data?.data?.refId }
  //       });
  //       dispatch({ type: "NOTIFY_SUB_PAGE_TO_DISPLAY", payload: { notifysubPageToDisplay: "notifyMeOTP" } });
  //     }
  //   } catch (error: any) {
  //     setIsGenericError(true);
  //     dispatch({ type: "LOADER", payload: { loading: false } });
  //   }
  // }

  function submitForm(formValues: any) {
    const mobileNum = formValues["mobileNumber"] as string;
    const mobileNumber = mobileNum.replace(/^0/, "966");
    const productName = lang === "en" ? productData?.name?.valueEn : productData?.name?.valueAr;
    const encryptedACNumber = mobileNumber ? jsencrypt.encrypt(mobileNumber) : "";
    const encryptedProductName = productName ? jsencrypt.encrypt(productName) : "";

    notifyMeOTPInitiate(lang, encryptedACNumber, encryptedProductName)
      .then((response: any) => {
        if (response.status === 200) {
          dispatch({ type: "LOADER", payload: { loading: false } });
          dispatch({
            type: "NOTIFY_DATA",
            payload: {
              mobile: formValues["mobileNumber"],
              email: formValues["email"],
              refId: response?.data?.data?.refId,
            },
          });
          dispatch({
            type: "NOTIFY_SUB_PAGE_TO_DISPLAY",
            payload: { notifysubPageToDisplay: "notifyMeOTP" },
          });
        } else {
          setIsGenericError(true);
          dispatch({ type: "LOADER", payload: { loading: false } });
        }
      }).catch(() => {
        setIsGenericError(true);
        dispatch({ type: "LOADER", payload: { loading: false } });
      });
  }

  const handleHeaderCancel = () => {
    window.location.reload();
  }

  const handleGenericError = () => {
    setIsGenericError(false);
    dispatch({ type: 'LOADER', payload: { loading: false } });
    window.location.reload();
  }


  return (
    <div className='NotifyMe__Container container'>
      {notifysubPageToDisplay === 'notifyMeLogin' && (
        <NotifyMeLogin
          handleSubmit={submitForm}
        />
      )}
      {notifysubPageToDisplay === 'notifyMeOTP' && (
        <NotifyMeOTP
          handleHeaderCancel={handleHeaderCancel}
        />
      )}
      {isGenericError && (
        <ErrorModal
          id={'otp_page_generic_error'}
          rtl={rtl}
          title={t('Generic_error')}
          description={""}
          firstButtonText={t('Got_it')}
          modalFirstButtonClick={handleGenericError}
        />
      )}
    </div>
  )
}

export default NotifyMe